<template>
  <main class="flex-auto ce-formulationRepo">
    <div class="ce-container flex pt4">
      <FilterBar />
      <main>
        <ProductResultsHint />
        <div class="ce-searchResults-topActionsBar flex">
          <div class="ce-mobileFilterBarToggle mr2">
            <button
              class="ce-btn ce-btn-grey"
              @click.prevent="$store.dispatch('toggleMobileFilterBar')">
              <fa-icon icon="filter" />
            </button>
          </div>

          <search-term-filter
            class="flex-auto"
            :placeholder="$t('formulationRepository.searchPage.searchPlaceholder')" />
        </div>

        <TabBar />

        <ResultView />
      </main>
    </div>
  </main>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import FilterBar from 'components/product-search/FilterBar.vue';
import ResultView from 'components/formulation-repo/ResultView.vue';
import TabBar from 'components/formulation-repo/TabBar.vue';
import SearchTermFilter from 'components/SearchTermFilter.vue';
import ProductResultsHint from 'components/formulation-repo/ProductResultsHint.vue';

export default {
  components: {
    FilterBar,
    TabBar,
    ResultView,
    SearchTermFilter,
    ProductResultsHint,
  },
  watch: {
    urlFilters() {
      this.search();
    }
  },
  mounted() {
    this.search();
  },
  computed: {
    ...mapState('generic', ['links']),
    ...mapGetters(['urlFilters', 'activeTab', 'isMobile'])
  },
  methods: {
    ...mapActions(['setTab', 'search'])
  }
};
</script>

<style lang="less">
@import '~styles/includes/base';
@import '~styles/includes/search-type-tabs';

.ce-formulationRepo {
  main {
    .flex-auto;
    background: @color-mono-100;

    .ce-searchResults-topActionsBar {
      margin-bottom: @space-3;

      .ce-searchField {
        margin-bottom: 0;
      }
    }

    @media screen and (min-width: @breakpoint-md) {
      .ce-mobileFilterBarToggle {
        display: none;
      }
    }

    @media screen and (min-width: @breakpoint-xxs) {
      padding: @space-3;
    }
  }
}
</style>
